import React from 'react';
import classnames from 'classnames';
import { ESortOrder } from 'store/common/types';
import { StackedIcon } from 'ui/StackedIcon';
import CaretUpIcon from 'ui/Icons/tabler/caret-up.component.svg';
import CaretDownIcon from 'ui/Icons/tabler/caret-down.component.svg';

export interface ISortIconProps {
  sortBy: string;
  newSortBy: string;
  sortOrder: ESortOrder;
}

export const SortIcon: React.FC<ISortIconProps> = React.memo(({ sortBy, newSortBy, sortOrder }) => {
  const isActive = newSortBy === sortBy;
  const isInactive = !isActive;

  // Determine fill colors for each caret based on sort state
  const topFillColor = classnames({
    'fill-ivory group-hover:fill-gray-40': isInactive,
    'fill-gray-100': isActive && sortOrder === ESortOrder.ASC,
    'fill-gray-40': isActive && sortOrder === ESortOrder.DESC,
  });

  const bottomFillColor = classnames({
    'fill-ivory group-hover:fill-gray-40': isInactive,
    'fill-gray-100': isActive && sortOrder === ESortOrder.DESC,
    'fill-gray-40': isActive && sortOrder === ESortOrder.ASC,
  });

  return (
    <span style={{ marginRight: '-18px', width: '38px' }} className="inline-block">
      <StackedIcon
        TopIcon={CaretUpIcon}
        BottomIcon={CaretDownIcon}
        topClassName={`w-4 h-4 ${topFillColor}`}
        bottomClassName={`w-4 h-4 ${bottomFillColor}`}
        stackDirection="vertical"
      />
    </span>
  );
});
